import Layout2 from '@/layout/Layout2'

export default [{
  path: '/doctors',
  component: Layout2,
  meta: { requiresAuth: true },
  children: [{
    path: '',
    component: () => import('@/components/doctors/Doctors')
  }, {
    path: 'create',
    component: () => import('@/components/doctors/CreateDoctor')
  }, {
    path: 'edit/:id',
    component: () => import('@/components/doctors/EditDoctor'),
    props: true
  }]
}]
